export default function loadFrameData(context, payload, done) {
    var account = payload.account;
    context.dispatch('FRAME_DATA_LOADED', { account: account });
    if (done)
        done();
}
